import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Tooltip } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import IconButton from "../../../../UI/IconButton";
import { IOpenFileProps, TMimeTypeMap } from "./models";

const translationPath = "components.fileItem.";

export const OpenFile = memo(
  ({
    fileName,
    loading,
    onOpenFileInNewTab,
    cdnUrl = false,
  }: IOpenFileProps) => {
    const { t } = useTranslation();

    const onClickHandler = useCallback(async () => {
      const file = await onOpenFileInNewTab();
      if (!file) return;

      if (cdnUrl) {
        const url = file.data;
        window.open(url, "_blank");
        return;
      }

      const mimeTypeMap: TMimeTypeMap = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        txt: "text/plain",
        pdf: "application/pdf",
        zip: "application/zip",
      };

      const byteCharacters = atob(file.data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {
        type: mimeTypeMap[file.format.toLowerCase()] || "application/pdf",
      });

      const blobUrl = URL.createObjectURL(blob);

      const newTab = window.open();
      if (!newTab) return;

      newTab.location.href = blobUrl;
    }, [onOpenFileInNewTab, cdnUrl]);

    return (
      <Tooltip title={t(`${translationPath}open_new_tab`)} placement="left">
        <Box>
          <IconButton size="small" disabled={loading} onClick={onClickHandler}>
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </Box>
      </Tooltip>
    );
  }
);
